<script>
  import axios from "axios";
  export let settings;
  export let dataapi;
  export let datanik;
  let apidata = [];
  let showform = false;
  axios
    .get(settings.url + "/sipade/lay_api/" + dataapi + "/" + datanik, {
      params: {
        authorization: settings.token,
      },
    })
    .then(function (response) {
      apidata = response.data;
      showform = true;
    });

  function changeB() {
    document.getElementById("idpenselectall").checked = false;
    [].forEach.call(
      document.querySelectorAll('input[type="checkbox"].idpenselect'),
      function (el) {
        el.checked = false;
      }
    );

    if (document.getElementById("skpdjenis_pindah").value == "2") {
      document.getElementById("idpenselectall").checked = true;
      [].forEach.call(
        document.querySelectorAll('input[type="checkbox"].idpenselect'),
        function (el) {
          el.checked = true;
        }
      );
      document.getElementById("skpdnokktp").value = "3";
    } else if (
      (document.getElementById("skpdjenis_pindah").value == "1") |
      (document.getElementById("skpdjenis_pindah").value == "3")
    ) {
      document.getElementsByClassName("kepkk").checked = true;
    } else if (document.getElementById("skpdjenis_pindah").value == "4") {
      [].forEach.call(
        document.querySelectorAll('input[type="checkbox"].idpenselect'),
        function (el) {
          el.checked = true;
        }
      );

      document.getElementsByClassName("kepkk").checked = false;
    } else {
      document.getElementById("idpenselectall").checked = false;
      [].forEach.call(
        document.querySelectorAll('input[type="checkbox"].idpenselect'),
        function (el) {
          el.checked = false;
        }
      );
    }
  }
      let selected;
      let selectedA;

</script>

{#if showform}
  <table border="0" width="100%" class="listtable layTemplate" id="SKPD-layTemplate">
    <tbody>

      <tr>
        <td class="labelform">Alasan Pindah</td>
        <td class="labelform">:</td>
        <td data-title="Alasan Pindah">
          <select
            name="skpdalasan"
            id="skpdalasan"
            class="form-select w-full m-b-10"
            bind:value={selected}>
            <option value="1">Pekerjaan</option>
            <option value="2">Pendidikan</option>
            <option value="3">Keamanan</option>
            <option value="4">Kesehatan</option>
            <option value="5">Perumahan</option>
            <option value="6" selected>Keluarga</option>
            <option value="7">Lainnya</option>
          </select>
          {#if selected == 7}
          <input
            name="skpdalasan_lain"
            id="skpdalasan_lain"
            class="w-full"
            type="text"
            placeholder="Tulis Alasan Lainnya" />
            {/if}
            
        </td>
      </tr>
      <tr>
        <td class="labelform">Jenis Kepindahan</td>
        <td class="labelform">:</td>
        <td data-title="Jenis Kepindahan">
          <select
            name="skpdjenis_pindah"
            id="skpdjenis_pindah"
            class="form-select w-full m-b-10"
            on:blur=""
            on:change={changeB}>
            <option value="1">Kep. Keluarga</option>
            <option value="2">Kep. Keluarga & Seluruh Angg. Keluarga</option>
            <option value="3">Kep. Keluarga & Sebagian Angg. Keluarga</option>
            <option value="4">Anggota Keluarga</option>
          </select>
        </td>
      </tr>
      <tr>
        <td class="labelform">Status Nomor KK Bagi Yang Tidak Pindah</td>
        <td class="labelform">:</td>
        <td data-title="Status Nomor KK Bagi Yang Tidak Pindah">
          <select name="skpdnokktp" id="skpdnokktp" class="form-select w-full">
            <option value="1">Numpang KK</option>
            <option value="2" selected="selected">Membuat KK Baru</option>
            <option value="3">Tidak ada anggota kel. yang ditinggal</option>
            <option value="4">Nomor KK Tetap</option>
          </select>
        </td>
      </tr>
      <tr>
        <td class="labelform">Status Nomor KK Bagi Yang Pindah</td>
        <td class="labelform">:</td>
        <td data-title="Status Nomor KK Bagi Yang Pindah">
          <select
            name="skpdnokkp"
            id="skpdnokkp" 
            class="form-select w-full" 
            bind:value={selectedA}>
            <option value="1">Numpang KK</option>
            <option value="2" selected="selected">Membuat KK Baru</option>
            <option value="3">Nomor Kep. Kel &amp; KTP Tetap</option>
          </select>
        </td>
      </tr>
      {#if selectedA == 1}
      <tr class="skpkkshow" >
        <td width="45%" class="labelform">Nomor KK Tujuan</td>
        <td width="2%" class="labelform">:</td>
        <td data-title="Nomor KK Tujuan">
          <input
            name="nokktujuan"
            class="form-input w-full"
            type="text"
            placeholder="Nomor KK Tujuan" />
        </td>
      </tr>
      <tr class="skpkkshow">
        <td width="45%" class="labelform">NIK Kepala Keluarga Tujuan</td>
        <td width="2%" class="labelform">:</td>
        <td data-title="NIK Kepala Keluarga Tujuan">
          <input
            name="nikkktujuan"
            class="form-input w-full"
            type="text"
            placeholder="Nik Kepala Keluarga Tujuan" />
        </td>
      </tr>

      <tr class="skpkkshow">
        <td width="45%" class="labelform">Nama Kepala Keluarga Tujuan</td>
        <td width="2%" class="labelform">:</td>
        <td data-title="Nama Kepala Keluarga Tujuan">
          <input
            name="nmkktujuan"
            class="form-input w-full"
            type="text"
            placeholder="Nama Kepala Keluarga Tujuan" />
        </td>
      </tr>
    {/if}
      <tr>
        <td class="labelform">Rencana Tanggal Pindah</td>
        <td class="labelform">:</td>
        <td data-title="Rencana Tanggal Pindah">
          <input
            name="skpdrtglpindah"
            maxlength="10"
            type="date"
            class="form-input w142"
            placeholder="Tgl Pindah"
            value={apidata.tgl} />
        </td>
      </tr>
      <tr>
        <td colspan="4">
          <h5>DATA NAMA YANG PINDAH</h5>
        </td>
      </tr>
      <tr>
        <td colspan="4" class="no-more-tables">
          <table class="listtable" border="0" width="100%">
            <thead>
              <tr>
                <td width="3%">No.</td>
                <td width="3%">
                  <input id="idpenselectall" type="checkbox" class="form-checkbox" />
                </td>
                <td>Nama Lengkap</td>
                <td>NIK</td>
                <td>HDK</td>
              </tr>
            </thead>
            <tbody id="dataanggota">
              {#if apidata.data.penduduk}
                {#each apidata.data.penduduk as d}
                  <tr>
                    <td class="nomor" data-title="Nomor">{d.no}</td>
                    <td data-title="Pilih">
                      <input
                        type="checkbox"
                        name="idpenselect[]"
                        value={d.id}
                        class="form-checkbox text-3xl idpenselect" />
                    </td>
                    <td data-title="Nama Lengkap">{d.nm}</td>
                    <td data-title="NIK">{d.id}</td>
                    <td data-title="HDK">{d.hdk}</td>
                  </tr>
                {/each}
              {:else}
                <tr>
                  <td colspan="5">
                    <div class="alert alert-standar">
                      Tidak Menemukan Data Yang Relevan
                    </div>
                  </td>
                </tr>
              {/if}
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  </table>
{/if}
